module.exports = __webpack_public_path__ + "img/Prescription-sent-icon.cb2d944e.webp";